<div class="container" *ngIf="isLoading">
  <mat-card style="margin-top: 50px">
    <mat-card-content><i class="fas fa-spinner fa-pulse"></i> Loading Data, Please Wait...</mat-card-content>
  </mat-card>
</div>
<div class="container" *ngIf="isError">
  <mat-card style="margin-top: 50px">
    <mat-card-content>{{errorMessage}}</mat-card-content>
  </mat-card>
</div>
<div class="container" *ngIf="!isLoading && !isError">
  <mat-card style="margin-top: 50px">
    <mat-card-header>
      <mat-card-title>
        <h1 style="margin-left: -20px;">
          {{this.targetInteractive?.interactName}} --
          <ng-container *ngIf="preFilterInteractive?.preFilteredInteractiveId === 0">
            Create New Pre-Filtered Interactive
          </ng-container>
          <ng-container *ngIf="preFilterInteractive?.preFilteredInteractiveId !== 0">
            Update Pre-Filtered Interactive
          </ng-container>
        </h1>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col-md-2"><b>Interactive Name:</b></div>
        <div class="col-md-10">
          <input matInput type="text" [(ngModel)]="preFilterInteractive.name" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-2"><b>Subscription:</b></div>
        <div class="col-md-10">
          <mat-select [(value)]="preFilterInteractive.subscriptionId">
            <mat-option *ngFor="let subscription of subscriptionHeaders" [value]="subscription.subscriptionId">
              {{ subscription.subscriptionName }} -- {{ subscription.organizationName }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card style="margin-top: 15px">
    <div class="row input-table-row">
      <div class="col-md-1">Key: </div>
      <div class="col-md-3">
        <mat-select [(value)]="selectedFilterKey" (selectionChange)="selectedFilterKeyChanged()">
          <mat-option *ngFor="let filterKey of preFilterKeys" [value]="filterKey">{{ filterKey.name }}</mat-option>
        </mat-select>
      </div>
      <div class="col-md-1">Value: </div>
      <div class="col-md-3">
        <ng-container *ngIf="selectedFilterKey" [ngSwitch]="selectedFilterKey?.keyType">
          <ng-container *ngSwitchCase="0">
            <mat-select [(value)]="selectedFilterValues" [placeholder]="'Select ' + selectedFilterKey.name" (selectionChange)="flatSelectionChange()" multiple>
              <input
                matInput
                (keyup)="onFilterKeyEvent($event.target.value)"
                [placeholder]="'Enter Search Criteria'"
                style="line-height: 2em; padding-left: 1em; font-size: 18px;"
              />
              <mat-option *ngFor="let filterKeyValue of filteredFlatValues" (onSelectionChange)="flatInputChanged($event)" [value]="filterKeyValue">{{ filterKeyValue.keyValue }}</mat-option>
            </mat-select>
          </ng-container>
          <ng-container *ngSwitchCase="1">
            <div class="hierarchy-select-container">
              <app-pre-filter-hierarchy-editor
                [preFilterKey]="selectedFilterKey" (currentSelectedValues)="hierarchySelectedValuesChanged($event)"
                [selectedValues]="initiallySelectedHierarchyValues"
                [allowSelect]="true"
                [title]="'Select ' + selectedFilterKey.name"
                [maxHeight]="400"
              >
              </app-pre-filter-hierarchy-editor>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="2">
            <input matInput [(ngModel)]="selectedFilterValueText" [placeholder]="'Enter ' + selectedFilterKey.name" />
          </ng-container>
        </ng-container>
      </div>
      <div class="col-md-4">
        <button mat-button class="piNarrowButton" (click)="addFilterKeyValue()">Add / Update Filter</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 mainLabel">Filter Key</div>
      <div class="col-md-4 mainLabel">Filter Value</div>
      <div class="col-md-4 mainLabel">Actions</div>
    </div>
    <ng-container *ngFor="let filterValue of preFilterCuratedValues; let idx = index;">
      <div class="row table-row">
        <div class="col-md-4">{{filterValue.filterKey}}</div>
        <div class="col-md-4">{{filterValue.filterValue}}</div>
        <div class="col-md-4">
          <button mat-button class="piNarrowButton" (click)="removeFilterValue(idx)">Remove</button>
        </div>
      </div>
    </ng-container>
  </mat-card>
  <mat-card style="margin-top: 15px">
    <mat-card-content>
      <app-share-editor allowModify="true" allowReadOnly="true" [avaialbleSubscriptions]="subscriptionHeaders" [(ngModel)]="shareState"></app-share-editor>
    </mat-card-content>
  </mat-card>
  <mat-card style="margin-top: 15px">
    <mat-card-content>
      <div class="row">
        <div class="col-md-9">
        </div>
        <div class="col-md-3">
          <button mat-button class="piButton" (click)="savePreFilteredInteractive()">Save Pre-Filtered Interactive</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
